import * as React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from './Button';

/**
 * Sober DS (v2) — QueryErrorState (Story 37.6 / auditoria fio a fio).
 *
 * Estado de ERRO de carregamento — NUNCA reutilizar o `Empty` de "sem dados" quando
 * a query falhou (o padrão transversal que fazia o app mentir: "Você ainda não tem
 * pacientes", "Caixa fechado", "Nenhuma campanha" apareciam em erro de API/rede).
 * Sempre em PT-BR, com "Tentar novamente" (refetch). Sem bordas/accents coloridos.
 */
export interface QueryErrorStateProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
  onRetry?: () => void;
  retrying?: boolean;
  retryLabel?: string;
}

export const QueryErrorState = React.forwardRef<HTMLDivElement, QueryErrorStateProps>(
  ({ className, title = 'Não foi possível carregar', description = 'Verifique sua conexão e tente novamente.', onRetry, retrying, retryLabel = 'Tentar novamente', ...props }, ref) => (
    <div
      ref={ref}
      role="alert"
      className={cn('flex flex-col items-center gap-3 px-6 py-20 text-center', className)}
      {...props}
    >
      <span className="grid h-[72px] w-[72px] place-items-center rounded-so-xl bg-sober-app text-sober-secondary [&_svg]:size-7">
        <AlertTriangle />
      </span>
      <span className="text-so-16 font-bold text-sober-text">{title}</span>
      <span className="max-w-[360px] text-so-14 text-sober-secondary">{description}</span>
      {onRetry ? (
        <Button variant="outline" onClick={onRetry} disabled={retrying} className="mt-1 gap-2">
          <RefreshCw className={retrying ? 'size-4 animate-spin' : 'size-4'} />
          {retryLabel}
        </Button>
      ) : null}
    </div>
  )
);
QueryErrorState.displayName = 'QueryErrorState';
